import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  filterArea: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: 15,
    width: "100%",
  },
  filter: {
    width: "180px",
    marginLeft: "auto",
  },
  trueIcon: {
    position: "absolute",
    marginTop: "-14px",
    marginLeft: "4px",
  },
  statusIcon: {
    position: "absolute",
    marginTop: "-10px",
    marginLeft: "0px",
    color: "#fff",
  },
  noIcon: {
    marginLeft: "14px",
  },
  statusLabel: {
    marginLeft: "35px",
    whiteSpace: "nowrap",
  },
}));

export default styles;
